export default {"src":"/_next/static/media/hot-news-gray-icon.3659af78.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};